import { Box, Flex, HStack, Image, Stack, Text } from "@chakra-ui/react";

import { NavButton } from "@/components/nav-button";

const PLUME_RESTRICTIONS_URL = "https://plumenetwork.xyz/terms-of-service";

export const AccessRestrictedPage = () => {
  return (
    <Flex
      align="center"
      flex="1"
      justify="center"
      px={[4, 6]}
      py={[20, 24, 28]}
    >
      <Stack align="center" gap={8} maxW="720px" textAlign="center" w="full">
        <Stack gap={3}>
          <Text
            color="text.secondary"
            fontFamily="heading"
            fontSize="2xl"
            fontWeight="500"
          >
            Access Restricted
          </Text>
          <Flex justify="center">
            <HStack gap={2}>
              <Image src="/assets/hub-logo-feather.svg" boxSize={8} />
              <Text
                color="text.primary"
                fontFamily="heading"
                fontSize={["2xl", "3xl"]}
                fontWeight="800"
                letterSpacing="-0.04em"
              >
                portal
              </Text>
            </HStack>
          </Flex>
        </Stack>

        <Stack gap={5} maxW="680px">
          <Text
            color="text.primary"
            fontFamily="heading"
            fontSize={["2xl", "3xl"]}
            fontWeight="500"
          >
            The content you are trying to access is not accessible in your
            jurisdiction.
          </Text>
          <Text
            color="text.secondary"
            fontSize={["md", "lg"]}
            lineHeight="tall"
          >
            Tokens underlying tokenized assets offered through the Plume Portal
            (&quot;Tokens&quot;) are not registered under the Securities Act of
            1933, as amended (the &quot;Act&quot;). Tokens are not offered or
            sold in the U.S., to U.S. persons (as defined in Rule 902(k) of the
            Act), or for the account or benefit of U.S. persons, or in or to
            persons in other restricted jurisdictions.
          </Text>
        </Stack>

        <HStack flexWrap="wrap" gap={3} justify="center">
          <NavButton
            direction="up-right"
            href={PLUME_RESTRICTIONS_URL}
            size="lg"
            variant="outline"
          >
            View Restrictions
          </NavButton>
        </HStack>

        <Box
          bg="linear-gradient(90deg, rgba(17,17,17,0.08) 0%, rgba(17,17,17,0) 100%)"
          borderRadius="full"
          h="1px"
          maxW="280px"
          w="full"
        />
      </Stack>
    </Flex>
  );
};
